// extracted by mini-css-extract-plugin
module.exports = {"last-week":"NoAccess--last-week--1cT99","lastWeek":"NoAccess--last-week--1cT99","description":"NoAccess--description--2umiT","graphic":"NoAccess--graphic--1xuuU"};